import Vue from 'vue'
import Vuex from 'vuex'
// 1安装插件
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        navIndex:sessionStorage['navIndex'] ? sessionStorage['navIndex'] : "1",
        mShowControlMeue:false,
        access_token:localStorage['access_token']?localStorage['access_token']:"",
        openid:localStorage['openid']?localStorage['openid']:"",
        refresh_token:localStorage['refresh_token']?localStorage['refresh_token']:"",
        // isLogin:localStorage['isLogin']?Boolean(localStorage['isLogin']):false,
        isLogin:false,
        isRealName:false,
    },
    mutations:{
        changeIndex(state,value){
            state.navIndex = value
            sessionStorage['navIndex'] = value
        },
        login(state,payload){
            state.access_token=payload.access_token;
            state.openid=payload.openid;
            state.refresh_token=payload.refresh_token;
            // state.isLogin=Boolean(payload.isLogin)
            localStorage['access_token']=payload.access_token;
            localStorage['openid']=payload.openid;
            localStorage['refresh_token']=payload.refresh_token;
            // localStorage['isLogin']=payload.isLogin;
        },
        changLoginState(state,value){
            state.isLogin = value
        },
        changRealNameState(state,value){
            state.isRealName = value
        },

    },
    // 异步修改仓库数据
    actions:{
        // context 上下文 
        getNavIndex(context,value){
            context.commit('changeIndex',value)
        },
        getLogin(context,value){
            context.commit('login',value)
        },
        getChangLoginState(context,value){
            context.commit('changLoginState',value)
        },
        getChangRealNameState(context,value){
            context.commit('changRealNameState',value)
        },
    }
})

export default store